import React, { useCallback, useContext, useEffect, useMemo, useState } from "react"
import { Children } from "../../../../../../../../../components/miscellianous/children"
import { BSParking } from "../../../../../../../../../core/dto/beem-shot/BSParking/BSParking"
import { ParkingEnum } from "../../../../../../../../../core/enum/beem-shot/ParkingEnum"
import { useBSParking } from "../../../../../../../../../core/hooks/beem-shot/useBSParking"
import { BSBuildingContext } from "../../../components/context/BSBuildingContext"

export const BSParkingListContext = React.createContext<BSParkingListStore>({} as BSParkingListStore)

export function BSParkingListContextProvider({ children }: Readonly<Children>): React.JSX.Element {
  const { getAllBSParking } = useBSParking()

  const { selectedBSBuilding } = useContext(BSBuildingContext)

  const [bsParkingList, setBSParkingList] = useState<BSParking[]>([])
  const [isBSParkingListLoading, setIsBSParkingListLoading] = useState<boolean>(true)

  const superstructureParkingList = useMemo(
    () => bsParkingList.filter((parking) => parking.typeParking === ParkingEnum.SUPER_STRUCTURE),
    [bsParkingList]
  )
  const infrastructureParkingList = useMemo(
    () => bsParkingList.filter((parking) => parking.typeParking === ParkingEnum.SOUTERRAIN),
    [bsParkingList]
  )

  const fetchAllBSParking: (buildingId: string) => Promise<BSParking[]> = useCallback(
    (buildingId) =>
      getAllBSParking(buildingId).then((newBSParkingList) => {
        setBSParkingList(newBSParkingList)
        setIsBSParkingListLoading(false)
        return newBSParkingList
      }),
    [getAllBSParking]
  )

  useEffect(() => {
    if (selectedBSBuilding?.id) {
      fetchAllBSParking(selectedBSBuilding.id)
    }
  }, [fetchAllBSParking, selectedBSBuilding])

  const bsParkingListStore = useMemo(
    () => ({
      isBSParkingListLoading,
      bsParkingList,
      superstructureParkingList,
      infrastructureParkingList,
      setBSParkingList,
      fetchAllBSParking,
    }),
    [
      isBSParkingListLoading,
      bsParkingList,
      superstructureParkingList,
      infrastructureParkingList,
      setBSParkingList,
      fetchAllBSParking,
    ]
  )
  return <BSParkingListContext.Provider value={bsParkingListStore}>{children}</BSParkingListContext.Provider>
}

export type BSParkingListStore = {
  isBSParkingListLoading: boolean
  bsParkingList: BSParking[]
  superstructureParkingList: BSParking[]
  infrastructureParkingList: BSParking[]
  setBSParkingList: React.Dispatch<React.SetStateAction<BSParking[]>>
  fetchAllBSParking(buildingId: string): Promise<BSParking[]>
}
